import { useEffect } from "react";

export const useOpenAddressOnErrors = (addressErrorList, addressTouchedList, manual, toggleManual) => {
  useEffect(() => {
    if (!manual) {
      for (let i = 0; i < addressErrorList.length; i++) {
        const willHaveErrorLabel = addressTouchedList[i] && addressErrorList[i];
        if (willHaveErrorLabel) {
          toggleManual(true);
          break;
        }
      }
    }
  }, [addressTouchedList, addressErrorList, manual, toggleManual]);
};